"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackExperimentAssigned = exports.track = exports.shouldTrack = void 0;

var _getWindow = _interopRequireDefault(require("./get-window"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable no-console */
var track = function track(_ref) {
  var action = _ref.action,
      label = _ref.label,
      category = _ref.category,
      value = _ref.value,
      callback = _ref.callback,
      _ref$interactive = _ref.interactive,
      interactive = _ref$interactive === void 0 ? false : _ref$interactive;
  var eventTracking = (0, _getWindow["default"])().uSwitchEventTracking;
  return eventTracking ? eventTracking(category, action, label, value, callback, !interactive) : console.log('gaEvent', {
    category: category,
    action: action,
    label: label,
    value: value,
    callback: callback,
    interactive: !interactive
  });
};

exports.track = track;

var trackExperimentAssigned = function trackExperimentAssigned(_ref2) {
  var flag = _ref2.flag,
      cohort = _ref2.cohort;
  return track({
    action: 'Experience Bucket',
    label: "".concat(flag, ":").concat(cohort),
    category: 'experiments'
  });
};

exports.trackExperimentAssigned = trackExperimentAssigned;

var shouldTrack = function shouldTrack(id, experimentIds) {
  if (experimentIds.includes(id)) {
    return false;
  }

  experimentIds.push(id);
  return true;
};

exports.shouldTrack = shouldTrack;